import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { ViewTrainersGridDataService } from 'common/services/data-services/admin/trainer/trainer-view/view-trainers-data.service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { ViewTrainersGridMetaModel } from 'common/models/page-models/View Trainers Model/view-trainers-grid-meta.model';
import { ViewTrainersListingModel } from 'common/models/page-models/View Trainers Model/view-trainers-params.odel';



 
@Injectable({
    providedIn: 'root'
})
export class ViewTrainersGridWidgetService extends GridWidgetService<TrainersModel, ViewTrainersListingModel> {
    constructor(protected override ds: ViewTrainersGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
          this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
      }
    
      getMetaModel(): MetaModel {
        const meta = new ViewTrainersGridMetaModel().getMetaModel();
        return meta;
      }

     

    

    
}